import * as React from 'react';
import { connect } from 'react-redux';
import { closeModal } from "../actions/modal";
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class AuthModal extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
    }

    render() {
        const {t} = this.props;

        return (
            <div>
                <div className={"modal fade " + (this.props.modal.show ? "in" : '')}
                    style={{
                        display: this.props.modal.show ? "block" : ''
                    }} id="authModal" tabIndex={-1} role="dialog" aria-labelledby="authModalLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(event: React.MouseEvent) => {
                                    this.props.closeModal();
                                }}><span aria-hidden="true">&times;</span></button>
                                <h5 className="modal-title" id="authModalLabel">
                                    {t("Пожалуйста, авторизуйтесь")}
                                </h5>
                            </div>
                            <div className="modal-body text-center">
                                {this.props.modal.text}
                            </div>
                            <div className="modal-footer text-center">
                                <NavLink to="/signup" type="button" className="btn btn-default">{t("Регистрация")}</NavLink>
                                <NavLink to="/login" type="button" className="btn btn-primary">{t("Логин")}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.modal.show && <div className="modal-backdrop fade in"></div>}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        modal: state.modal
    };
}

export default connect(mapStateToProps, { closeModal })(withTranslation()(AuthModal));